import { defineMessages } from 'react-intl';

export const templatePickerListMessages = defineMessages({
  searchPlaceholder: {
    defaultMessage: 'Search your templates',
    id: '2ZOP0n7S8Z',
    description: 'Placeholder in the template picker search field',
  },
  searchAria: {
    defaultMessage: 'Search templates',
    id: 'rnGztlHWCh',
    description: 'Aria label for the template picker search field',
  },
  loadingTemplates: {
    defaultMessage: 'Loading templates',
    id: 'Hu9t7th8o4',
    description: 'Loading state while document templates fetch',
  },
  noSearchResults: {
    defaultMessage: 'No templates match your search.',
    id: '0eaAdhbh4b',
    description: 'Empty state when template search has no matches',
  },
  noTemplates: {
    defaultMessage: "You don't have any templates yet.",
    id: '+SnpOvgCFS',
    description: 'Empty state when the user has no templates',
  },
  noSearchMatches: {
    defaultMessage: 'No templates match your search.',
    id: '0eaAdhbh4b',
    description: 'Empty state when template search has no matches',
  },
  noTemplatesYet: {
    defaultMessage: "You don't have any templates yet.",
    id: '+SnpOvgCFS',
    description: 'Empty state when the user has no templates',
  },
  untitledTemplate: {
    defaultMessage: 'Untitled template',
    id: 'x+w+5oX5V0',
    description: 'Fallback name for a template without a title',
  },
  loading: {
    defaultMessage: 'Loading',
    id: 'oZY+k7XMYX',
    description: 'Loading label for clarification answer template lookup',
  },
  templateUnavailable: {
    defaultMessage: 'Template unavailable',
    id: 'YjTZfWrbEE',
    description: 'Fallback when a clarification template id cannot be resolved',
  },
});
